import R from 'ramda'
import { Argv } from 'yargs'

import { createIOSCircleEnvs } from './create-ios'
import { createAndroidCircleEnvs } from './create-android'

const platformNotSupplied = R.propEq('platform', false)
const platformIsiOS = R.propEq('platform', 'ios')

const generateAll = () => {
  console.error('No platform provided.')
}

const generateForPlatform = R.ifElse(
  platformIsiOS,
  async () => createIOSCircleEnvs(),
  async () => createAndroidCircleEnvs(),
)

export const command = 'create [platform]'
export const desc = 'Generate CircleCI [platform] envs for a project'
export const builder = (yargs: Argv): Argv => yargs.default('platform', false)
export const handler = R.ifElse(platformNotSupplied, generateAll, generateForPlatform)
